import { render, staticRenderFns } from "./AnomalyOrphanTeachers.vue?vue&type=template&id=9f015094&"
import script from "./AnomalyOrphanTeachers.vue?vue&type=script&lang=js&"
export * from "./AnomalyOrphanTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports